module.exports = __webpack_public_path__ + "static/media/puzzle-time-bg.png";